<template>
  <ConfirmationComponent />
</template>

<script>
// @ is an alias to /src
import ConfirmationComponent from "@/components/Confirmation/Confirmation.vue";

export default {
  name: "Confirmation",
  components: {
    ConfirmationComponent
  }
};
</script>
